<Modal />
<div class="acs" v-if="showContent">
    <div class="acs__wrapper">
        <div class="acs__content">
            <router-view />
        </div>
    </div>
</div>
